export default __webpack_public_path__ + "static/0317-4be0e6a40bd214aea96a9ebadf3a08e3.png";